import "./index.scss";

export const GridTwoColumn = ({children}) => (
  <div className="grid-two-column">{children}</div>
);
